import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import appEn from '../../../shared/locale/en.json' with { type: 'json' };
import appEnUS from '../../../shared/locale/en-US.json' with { type: 'json' };
import appJa from '../../../shared/locale/ja.json' with { type: 'json' };
import appKo from '../../../shared/locale/ko.json' with { type: 'json' };
import appZhCN from '../../../shared/locale/zh-CN.json' with { type: 'json' };
import appZhTW from '../../../shared/locale/zh-TW.json' with { type: 'json' };
import siteEn from './en.json' with { type: 'json' };
import siteEnUS from './en-US.json' with { type: 'json' };
import siteJa from './ja.json' with { type: 'json' };
import siteKo from './ko.json' with { type: 'json' };
import siteZhCN from './zh-CN.json' with { type: 'json' };
import siteZhTW from './zh-TW.json' with { type: 'json' };

/**
 * The site merges the main app's locale files with its own:
 *   - common strings (column.*, option.*, status.*, report.*, …) come from
 *     shared/locale/{en,en-US,ja,ko,zh-CN,zh-TW}.json — the app is the single
 *     source of truth.
 *   - site-unique marketing strings (site.*, usecase.*) come from this
 *     module's en.json / ja.json / ko.json / zh-*.json and override any
 *     colliding app key.
 *
 * This is the ONLY module that initialises i18next for the site build. Web
 * components that import `web/src/locale/i18n.js` are redirected here by
 * the `redirectWebI18n` Vite plugin, so the merged resources stay in charge.
 */
i18n.use(initReactI18next).init({
	resources: {
		en: { translation: { ...appEn, ...siteEn } },
		'en-US': { translation: { ...appEnUS, ...siteEnUS } },
		ja: { translation: { ...appJa, ...siteJa } },
		ko: { translation: { ...appKo, ...siteKo } },
		'zh-CN': { translation: { ...appZhCN, ...siteZhCN } },
		'zh-TW': { translation: { ...appZhTW, ...siteZhTW } },
	},
	fallbackLng: 'en',
	interpolation: { escapeValue: false },
	// No async backend — initialise synchronously so the SSR prerender can
	// render a route immediately after i18n.changeLanguage().
	initImmediate: false,
});

// Tell the app's i18n module (web/src/locale/i18n.js) not to re-initialise
// over these merged resources if it is imported via a reused component.
globalThis.__THYME_I18N_INITIALISED__ = true;

export { i18n };
